<template>
  <v-layout row wrap>
    <v-dialog
      v-model="json_data.status"
      fullscreen
      transition="dialog-bottom-transition"
      :overlay="false"
    >
      <v-card style="background-color:#E0E0E0;">
        <v-toolbar dark color="primary">
          <v-tooltip bottom>
            <v-btn slot="activator" icon dark @click="closeDialog">
              <v-icon>close</v-icon>
            </v-btn>
            <span>{{$t('close')}}</span>
          </v-tooltip>
          <v-toolbar-title>
            <span>{{ json_data.save_type == 'create' ? $t('menu.ChangeWorkplanCreate') : $t('menu.ChangeWorkplanEdit') }}</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn flat dark @click="json_data.save_type == 'create' ? onSave() : onUpdate()">
            <v-icon>save</v-icon>
            <span class="px-2">{{ json_data.save_type == 'create' ? $t('create') : $t('save') }}</span>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container background fluid pa-4>
            <v-layout row wrap pa-4 style="background-color:#fff; margin-top:5px; border-radius:5px;">
              <v-flex md12 sm12 xs12>
                <v-form ref="form" v-model="form_valid">
                  <v-layout row wrap>
                    <v-flex lg4 md4 sm6 xs12 pa-1>
                      <v-text-field
                        :label="$t('doc_no')"
                        v-model="form_model.doc_no"
                        :rules="form_rules.doc_no"
                        hide-details
                        append-icon="fas fa-plus-circle"
                        required
                        @click:append="doNewGuid"
                      />
                    </v-flex>
                     <v-flex lg4 md4 sm6 xs12 pa-1>
                      <v-select
                        :items="profilePlan"
                        v-model="profile"
                        :label="$t('menu.WorkPlanList')"
                        item-text="name"
                        item-value="code"
                        hide-details
                        required
                        @change="planChange(profile)"
                      />
                    </v-flex>
                    <v-flex lg4 md4 sm6 xs12 pa-1>
                      <v-select
                        :items="profileConditions"
                        v-model="Conditions"
                        :label="$t('Deduction_conditions')"
                        item-text="name"
                        item-value="code"
                        hide-details
                        required
                      />
                    </v-flex>
                    <v-flex lg4 md4 sm6 xs12 pa-1>
                      <v-text-field :label="$t('remark')" v-model="form_model.remark" hide-details />
                    </v-flex>
                    <v-flex lg4 md4 sm6 xs12 pa-1>
                      <v-autocomplete
                        :loading="loading"
                        v-model="name"
                        :items="Employee_List"
                        item-text="name"
                        item-value="name"
                        :label="$t('employee_code')"
                        append-icon="search"
                        clearable
                        hide-details
                        required
                        multiple
                      >
                      <template slot="selection" slot-scope="{ item, index }">
                      <span v-if="index === 0">{{ item.name }}</span>
                    <span
                      v-if="index === 1"
                      class="grey--text caption"
                    >(+{{ name.length - 1 }} others)</span>
                  </template>
                      <template slot="prepend-item">
                          <v-list-tile ripple @click="toggles" class="checkEmp">
                            <v-list-tile-action>
                              <v-checkbox
                                v-model="isChecked"
                                color="primary"
                                :indeterminate="selectSomeEmp"
                              ></v-checkbox>
                            </v-list-tile-action>
                            <v-list-tile-content>
                              <v-list-tile-title>Select All</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                          <v-divider class="mt-2"></v-divider>
                        </template>
                        <template slot="append-item">
                          <v-divider class="mb-2"></v-divider>
                        </template></v-autocomplete>
                    </v-flex>
                  </v-layout>
                  <br>
                    <!-- <v-flex md2 sm2 xs6 pa-1>
                      <v-select
                        v-model="name"
                        :items="Employee_List"
                        item-text="name"
                        item-value="name"
                        :label="$t('employee_code')"
                        multiple
                      >
                        <template slot="prepend-item">
                          <v-list-tile ripple @click="toggles" class="checkEmp">
                            <v-list-tile-action>
                              <v-checkbox
                                v-model="isChecked"
                                color="primary"
                                :indeterminate="selectSomeEmp"
                              ></v-checkbox>
                            </v-list-tile-action>
                            <v-list-tile-content>
                              <v-list-tile-title>Select All</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                          <v-divider class="mt-2"></v-divider>
                        </template>
                        <template slot="append-item">
                          <v-divider class="mb-2"></v-divider>
                        </template>
                      </v-select>
                    </v-flex> -->

                    <!-- <v-flex md2 sm3 xs6 pa-1>
                      <v-autocomplete
                        :loading="loading"
                        v-model="form_model.emp_code"
                        :items="Employee_List"
                        item-text="name"
                        item-value="code"
                        :label="$t('employee_code')"
                        append-icon="search"
                        :rules="form_rules.emp_code"
                        hide-details
                        clearable
                        required
                        allow-overflow
                      />
                    </v-flex>-->
                    

                  <!-- <v-layout xs6 v-show="manualBox" row wrap>
                    <v-flex md12 sm12 xs12 pa-1>
                      <v-radio-group v-model="radioGroup" row>
                         <span>{{$t('calculationmethod')}} : &nbsp;</span>
                          <v-radio :label="$t('shiftwork')" :value="1"></v-radio>
                          <v-radio :label="$t('hourswork')" :value="2"></v-radio>
                      </v-radio-group>
                    </v-flex>
                    
                      <v-flex md2 sm2 xs6 pa-1>
                       <v-text-field
                          label="ช่วงที่1:เข้า"
                          v-model="form_model.start_time_1"
                          hide-details
                          type="time"
                        />
                    </v-flex>
                    <v-flex md2 sm2 xs6 pa-1>
                      <v-text-field
                        label="ออก"
                        v-model="form_model.end_time_1"
                        hide-details
                        type="time"
                      />
                    </v-flex>
                    <v-flex md2 sm2 xs6 pa-1>
                      <v-text-field
                        label="ช่วงที่2:เข้า"
                        v-model="form_model.start_time_2"
                        hide-details
                        type="time"
                      />
                    </v-flex>
                    <v-flex md2 sm2 xs6 pa-1>
                      <v-text-field
                        label="ออก"
                        v-model="form_model.end_time_2"
                        hide-details
                        type="time"
                      />
                    </v-flex>
                    <v-flex md2 sm2 xs6 pa-1>
                      <v-text-field
                        label="ช่วงที่3:เข้า"
                        v-model="form_model.start_time_3"
                        hide-details
                        type="time"
                      />
                    </v-flex>
                    <v-flex md2 sm2 xs6 pa-1>
                      <v-text-field
                        label="ออก"
                        v-model="form_model.end_time_3"
                        hide-details
                        type="time"
                      />
                    </v-flex>
                    <v-flex md2 sm2 xs6 pa-1>
                      <v-text-field
                        label="ช่วงที่4:เข้า"
                        v-model="form_model.start_time_4"
                        hide-details
                        type="time"
                      />
                    </v-flex>
                    <v-flex md2 sm2 xs6 pa-1>
                      <v-text-field
                        label="ออก"
                        v-model="form_model.end_time_4"
                        hide-details
                        type="time"
                      />
                    </v-flex>
                    <v-flex md2 sm2 xs6 pa-1>
                      <v-text-field
                        label="เวลาพัก"
                        v-model="form_model.break_hour"
                        hide-details
                        type="number"
                      />
                    </v-flex>
                      <v-flex md2 sm2 xs6 pa-1>
                      <v-text-field
                        label="ชม.ทำงาน"
                        v-model="form_model.working_hours"
                        hide-details
                        type="number"
                      />
                    </v-flex>
                  </v-layout>-->

                  <v-layout row wrap mt-2>
                    <v-flex md6 xs12 pa-1 v-show="manualBox">
                      <v-layout xs6  row wrap>
                        <v-flex md2 sm2 xs12 pa-1>
                        <span>{{$t('calculationmethod')}} : &nbsp;</span>
                        </v-flex>
                        <v-flex md6 sm6 xs12 pa-1>
                          <v-radio-group v-model="radioGroup" row>
                            <v-radio :label="$t('shiftwork')" :value="1"></v-radio>
                            <!-- <v-radio :label="$t('hourswork')" :value="2"></v-radio> -->
                          </v-radio-group>
                        </v-flex>
                        <v-layout xs12 v-if="radioGroup==1" row wrap>   
                          <v-flex md2 sm2 xs12 pa-1>
                             <p style="font-size:1.15em;margin-top:20px;">{{$t('time')}} 1 : &nbsp;</p>
                          </v-flex>
                          <v-flex md5 sm5 xs6 pa-1>
                            <v-text-field
                              :label="$t('in')"
                              v-model="form_model.start_time_1"
                              hide-details
                              type="time"
                            />
                          </v-flex>
                          <v-flex md5 sm5 xs6 pa-1>
                            <v-text-field
                              :label="$t('out')"
                              v-model="form_model.end_time_1"
                              hide-details
                              type="time"
                            />
                          </v-flex>
                          <br>
                           <v-flex md2 sm2 xs12 pa-1>
                             <p style="font-size:1.15em;margin-top:20px;">{{$t('time')}} 2 : &nbsp;</p>
                          </v-flex>
                          <v-flex md5 sm5 xs6 pa-1>
                            <v-text-field
                              :label="$t('in')"
                              v-model="form_model.start_time_2"
                              hide-details
                              type="time"
                            />
                          </v-flex>
                          <v-flex md5 sm5 xs6 pa-1>
                            <v-text-field
                              :label="$t('out')"
                              v-model="form_model.end_time_2"
                              hide-details
                              type="time"
                            />
                          </v-flex>
                           <!-- <v-flex md2 sm2 xs12 pa-1>
                             <p style="font-size:1.15em;margin-top:20px;">{{$t('time')}} 3 : &nbsp;</p>
                          </v-flex>
                          <v-flex md5 sm5 xs6 pa-1>
                            <v-text-field
                              :label="$t('in')"
                              v-model="form_model.start_time_3"
                              hide-details
                              type="time"
                            />
                          </v-flex>
                          <v-flex md5 sm5 xs6 pa-1>
                            <v-text-field
                              :label="$t('out')"
                              v-model="form_model.end_time_3"
                              hide-details
                              type="time"
                            />
                          </v-flex>
                           <v-flex md2 sm2 xs12 pa-1>
                             <p style="font-size:1.15em;margin-top:20px;">{{$t('time')}} 4 : &nbsp;</p>
                          </v-flex>
                          <v-flex md5 sm5 xs6 pa-1>
                            <v-text-field
                             :label="$t('in')"
                              v-model="form_model.start_time_4"
                              hide-details
                              type="time"
                            />
                          </v-flex>
                          <v-flex md5 sm5 xs6 pa-1>
                            <v-text-field
                             :label="$t('out')"
                              v-model="form_model.end_time_4"
                              hide-details
                              type="time"
                            />
                          </v-flex> -->
                           <v-flex md2 sm2 xs12 pa-1>
                             <p style="font-size:1.15em;margin-top:20px;">{{$t('Breaktime')}}  : &nbsp;</p>
                          </v-flex>
                          <v-flex md5 sm5 xs6 pa-1>
                            <v-text-field
                              :label="$t('Breaktime')"
                              v-model="form_model.break_hour"
                              hide-details
                              type="number"
                            />
                          </v-flex>
                           <v-flex md5 sm5 xs6 pa-1>
                      <v-text-field
                        label="ชม.ทำงาน"
                        v-model="form_model.working_hours"
                        hide-details
                        type="number"
                      />
                    </v-flex>
                        </v-layout>
                        <!-- <v-layout xs12 v-if="radioGroup==2" row wrap>
                          <v-flex md2 sm2 xs12 pa-1>
                             <p style="font-size:1.15em;margin-top:20px;">{{$t('hourswork')}}  : &nbsp;</p>
                          </v-flex>
                          <v-flex md2 sm2 xs6 pa-1>
                            <v-text-field
                              :label="$t('hourswork')"
                              v-model="form_model.working_hours"
                              hide-details
                              type="number"
                            />
                          </v-flex>
                        </v-layout> -->
                      </v-layout>
                    </v-flex>

                    <v-flex md6 xs12 pa-1 v-show="manualBox">
                      <v-card>
                        <v-layout row wrap>
                          <v-flex xs12>
                            <v-date-picker
                              v-model="date_picker_model.date"
                              full-width
                              @click:date="onDateClick()"
                            />
                          </v-flex>
                        </v-layout>
                      </v-card>
                      <v-layout row wrap v-for="(item, index) in event" :key="index">
                        <v-flex md3 sm6 xs6 pa-1>
                          <v-text-field
                            v-model="item.date"
                            label="วันที่"
                            type="date"
                            hide-details
                            readonly
                          />
                        </v-flex>
                        <v-flex md5 sm6 xs6 pa-1>
                          <v-select
                            :items="profilePlan"
                            v-model="item.profile_plan"
                            :rules="form_rules.profile"
                            :label="$t('Deduction_conditions')"
                            item-text="name"
                            item-value="code"
                            hide-details
                            required
                          />
                        </v-flex>
                        <v-flex md3 sm6 xs5 pa-1>
                          <v-select
                            :items="profileConditions"
                            v-model="item.profile_condition"
                            :rules="form_rules.profile"
                            label="เงื่อนไขการจ่ายเงิน"
                            item-text="name"
                            item-value="code"
                            hide-details
                            required
                          />
                        </v-flex>
                        <v-flex md1 sm1 xs1 pa-1>
                          <v-btn color="error" flat icon @click="onRemoveItem(index)">
                            <v-icon>highlight_off</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 pa-1 v-show="!manualBox">
                      <!-- mobile -->
                      <v-layout row wrap  class="hidden-sm-and-up">
                         <v-flex xs12 pa-1 >
                                <v-card>
                                  <v-layout row wrap >
                                    <v-flex xs12>
                                      <v-date-picker
                                        v-model="date_picker_model.date"
                                        full-width
                                        @click:date="onDateClick()"
                                      />
                                    </v-flex>
                                  </v-layout>
                                </v-card>
                              </v-flex>
                      <v-flex xs12 pa-1>
                      <v-layout row wrap v-for="(item, index) in event" :key="index" >
                        <v-flex md3 sm3 xs12 pa-1>
                          <v-text-field
                            v-model="item.date"
                            label="วันที่"
                            type="date"
                            hide-details
                            readonly
                          />
                        </v-flex>
                        <v-flex md5 sm6 xs12 pa-1>
                          <v-select
                            :items="profilePlan"
                            v-model="item.profile_plan"
                            :rules="form_rules.profile"
                            :label="$t('Deduction_conditions')"
                            item-text="name"
                            item-value="code"
                            hide-details
                            required
                          />
                        </v-flex>
                        <v-flex md3 sm5 xs10 pa-1>
                          <v-select
                            :items="profileConditions"
                            v-model="item.profile_condition"
                            :rules="form_rules.profile"
                            label="เงื่อนไขการจ่ายเงิน"
                            item-text="name"
                            item-value="code"
                            hide-details
                            required
                          />
                        </v-flex>
                        <v-flex md1 sm1 xs1 pa-1>
                          <v-btn color="error" flat icon @click="onRemoveItem(index)">
                            <v-icon>highlight_off</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                     </v-flex>
                      </v-layout> 
                      <!-- desktop -->
                        <v-layout row wrap  class="hidden-xs-only">
                         <v-flex xs6 pa-1 >
                                <v-card>
                                  <v-layout row wrap >
                                    <v-flex xs12>
                                      <v-date-picker
                                        v-model="date_picker_model.date"
                                        full-width
                                        @click:date="onDateClick()"
                                      />
                                    </v-flex>
                                  </v-layout>
                                </v-card>
                              </v-flex>
                      <v-flex xs6 pa-1>
                      <v-layout row wrap v-for="(item, index) in event" :key="index" >
                        <v-flex lg3 md4 sm12 xs12 pa-1>
                          <v-text-field
                            v-model="item.date"
                            label="วันที่"
                            type="date"
                            hide-details
                            readonly
                          />
                        </v-flex>
                        <v-flex lg5 md8 sm12 xs12 pa-1>
                          <v-select
                            :items="profilePlan"
                            v-model="item.profile_plan"
                            :rules="form_rules.profile"
                            :label="$t('Deduction_conditions')"
                            item-text="name"
                            item-value="code"
                            hide-details
                            required
                          />
                        </v-flex>
                        <v-flex lg3 md11 sm10 xs12 pa-1>
                          <v-select
                            :items="profileConditions"
                            v-model="item.profile_condition"
                            :rules="form_rules.profile"
                            label="เงื่อนไขการจ่ายเงิน"
                            item-text="name"
                            item-value="code"
                            hide-details
                            required
                          />
                        </v-flex>
                        <v-flex lg1 md1 sm1 xs1 pa-1>
                          <v-btn color="error" flat icon @click="onRemoveItem(index)">
                            <v-icon>highlight_off</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                     </v-flex>
                      </v-layout> 

                    </v-flex>
                  </v-layout>
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-layout row wrap>
            <v-flex xs12 text-xs-right>
              <v-btn
                color="success"
                @click="json_data.save_type == 'create' ? onSave() : onUpdate()"
              >
                <v-icon>save</v-icon>
                <span class="px-2">{{ json_data.save_type == 'create' ? $t('create') : $t('save') }}</span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" :timeout="3500" :top="'top'" :color="'error'">
      {{ errmsg }}
      <v-btn dark flat @click="snackbar = false">X</v-btn>
    </v-snackbar>


  <!-- select Employee -->
  <v-layout row justify-center>
    <v-dialog v-model="Employee_dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{$t('Select_Employee')}}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
               <v-flex md12 sm12 xs12 pa-1>
                      <v-select
                        v-model="name"
                        :items="Employee_List"
                        item-text="name"
                        item-value="name"
                        :label="$t('Select_Employee')"
                        multiple
                      >
                        <template slot="prepend-item">
                          <v-list-tile ripple @click="toggles" class="checkEmp">
                            <v-list-tile-action>
                              <v-checkbox
                                v-model="isChecked"
                                color="primary"
                                :indeterminate="selectSomeEmp"
                              ></v-checkbox>
                            </v-list-tile-action>
                            <v-list-tile-content>
                              <v-list-tile-title>Select All</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                          <v-divider class="mt-2"></v-divider>
                        </template>
                        <template slot="append-item">
                          <v-divider class="mb-2"></v-divider>
                        </template>
                      </v-select>
                    </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="Employee_dialog = false">Close</v-btn>
          <v-btn color="blue darken-1" flat @click="Employee_dialog = false">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>


  </v-layout>
</template>
<script>
/* eslint-disable */
import { mapState, mapActions } from "vuex";
import DocumentService from "@/services/DocumentService";
import SettingService from "@/services/SettingService";
import Utils from "@/utils/";
export default {
  props: {
    json_data: Object
  },
  watch: {
    json_data(val) {
      if (val.data != null) {
        this.form_model = val.data;
      } else {
        this.clearForm();
        this.doNewGuid();
      }
    }
  },
  data: () => ({
    Employee_dialog:false,
    name: [],
    EmployeeList:[],
    isChecked: false,
    manualBox: false,
    radioGroup: 1,
    snackbar: false,
    errmsg: "",
    profile: "",
    Conditions: "",
    form_model: {
      doc_no: "",
      emp_code: "",
      start_time_1: "",
      start_time_2: "",
      start_time_3: "",
      start_time_4: "",
      end_time_1: "",
      end_time_2: "",
      end_time_3: "",
      end_time_4: "",
      working_hours: 0,
      break_hour: 0,
      remark: "",
      creator_code: localStorage._usercode
    },
    event: [],
    form_rules: {
      doc_no: [v => !!v || "do not empty."],
      emp_code: [v => !!v || "do not empty."],
      profile: [v => !!v || "do not empty."]
    },
    form_valid: false,
    profilePlan: [],
    profileConditions: [],
    calendar_model: {
      today: new Date().toISOString().slice(0, 10),
      start: new Date().toISOString().slice(0, 10),
      end: new Date().toISOString().slice(0, 10)
    },
    date_picker_model: {
      date: new Date().toISOString().slice(0, 10),
      toggle: false
    }
  }),
  created: function() {
    this.EmployeeList = this.Employee_List.length;
    console.log(this.EmployeeList);
    this.doNewGuid();
    this.getEmployee("newData");
    this.getProfilePlan();
    this.getProfileConditions();
  },
  computed: {
    ...mapState("filter", ["loading", "Employee_List"]),
    selectAllEmp() {
      return this.name.length === this.Employee_List.length;
    },
    selectSomeEmp() {
      console.log(this.name);
      return this.name.length > 0 && !this.selectAllEmp;
    }
  },
  methods: {
    ...mapActions("filter", ["getEmployee"]),
    closeDialog() {
      this.$refs.form.reset();
      this.$emit("close-dialog");
      this.clearForm();
    },
    clearForm() {
      this.manualBox = false;
      this.profile = "";
      this.Conditions = "";
      this.event = [];
      this.form_model = {
        doc_no: "",
        emp_code: "",
        start_time_1: "",
        start_time_2: "",
        start_time_3: "",
        start_time_4: "",
        end_time_1: "",
        end_time_2: "",
        end_time_3: "",
        end_time_4: "",
        working_hours: 0,
        break_hour: 0,
        remark: "",
        creator_code: localStorage._usercode
      };
      this.date_picker_model = {
      date: new Date().toISOString().slice(0, 10),
      toggle: false
    }
    },
    planChange(detail) {
      if (detail == "manual") {
        this.manualBox = true;
      } else {
        this.manualBox = false;
      }
    },
    doNewGuid() {
      this.form_model.doc_no = Utils.newGuid("WP");
    },
    setselectEmp(){
        let value = data.split(" - ");
        console.log(value[0] + " : " + value[1]);
       return value[0]
    },
    toggles() {
      this.$nextTick(() => {
        console.log(this.selectAllEmp);
        if (this.selectAllEmp) {
          this.name = [];
          this.isChecked = false;
        } else {
          this.isChecked = true;
          this.name = [];
          this.Employee_List.forEach(data => {
            this.name.push(data.name);
          });
        }
      });
    },
    getProfilePlan() {
      this.profilePlan = [];
      SettingService.getProfilePlan()
        .then(res => {
          this.profilePlan.push({ code: "manual", name: "กำหนดเอง" });
          this.profilePlan.push({ code: "holiday", name: "วันหยุด" });
          res.data.content.forEach(element => {
            this.profilePlan.push({ code: element.code, name: element.name });
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    getProfileConditions() {
      this.profileConditions = [];
      SettingService.getProfileConditions()
        .then(res => {
          this.profileConditions = res.data.content;
        })
        .catch(err => {
          console.log(err);
        });
    },
    async onSave() {
      if (this.form_valid) {
        let v =this;
        let holidayplan = [];
        let profileplan = [];
        let manualNull = 0;
        await v.name.forEach(function(data) {
          let value = data.split(" - ");
          console.log(value[0] + " : " + value[1]);
          console.log("e",v.event);
          v.event.forEach(element => {
            if (element.profile_plan == "holiday") {
              holidayplan.push({
                emp_code: value[0] ,
                holiday_date: element.date,
                creator_code: v.form_model.creator_code,
                doc_no: v.form_model.doc_no,
                remark: v.form_model.remark
              });
            } else if (element.profile_plan == "manual") {
              console.log(element);
              if (
                (v.form_model.start_time_1 == "" ||
                  v.form_model.start_time_1 == null) &&
                (v.form_model.end_time_1 == "" ||
                  v.form_model.end_time_1 == null)
              ) {
                manualNull += 1;
              } else {
                profileplan.push({
                  emp_code: value[0] ,
                  plan_date: element.date,
                  end_date: element.date,
                  shift_profile: element.profile_plan,
                  conditions_profile: element.profile_condition,
                  creator_code: v.form_model.creator_code,
                  doc_no: v.form_model.doc_no,
                  remark: v.form_model.remark,
                  working_hours: v.form_model.working_hours,
                  break_hour: v.form_model.break_hour,
                  start_time_1: v.form_model.start_time_1,
                  start_time_2: v.form_model.start_time_2,
                  start_time_3: v.form_model.start_time_3,
                  start_time_4: v.form_model.start_time_4,
                  end_time_1: v.form_model.end_time_1,
                  end_time_2: v.form_model.end_time_2,
                  end_time_3: v.form_model.end_time_3,
                  end_time_4: v.form_model.end_time_4
                });
              }
            } else {
              profileplan.push({
                emp_code: value[0] ,
                plan_date: element.date,
                 end_date: element.date,
                shift_profile: element.profile_plan,
                conditions_profile: element.profile_condition,
                creator_code: v.form_model.creator_code,
                doc_no: v.form_model.doc_no,
                remark: v.form_model.remark
              });
            }
          });
        });
        if (manualNull == 0) {
          await this.saveWorkPlan(profileplan);
          await this.saveHolidayPlan(holidayplan);
          this.closeDialog();
        } else {
          this.snackbar = true;
          this.errmsg = "กรุณาเพิ่มช่วงเวลาทำงาน กำหนดเอง";
          this.manualBox = true;
        }
      }
    },
    saveWorkPlan(data) {
      console.log(data);
      if (data.length > 0) {
        DocumentService.createChangeWorkPlan(data)
          .then(res => {})
          .catch(err => {
            this.snackbar = true;
            this.errmsg = "Error :" + err.response.data.message;
          });
      }
    },
    saveHolidayPlan(data) {
      console.log(data);
      if (data.length > 0) {
        DocumentService.createChangeHolidayPlan(data)
          .then(res => {})
          .catch(err => {
            this.snackbar = true;
            this.errmsg = "Error :" + err.response.data.message;
          });
      }
    },
    onUpdate() {
      if (this.form_valid) {
      }
    },
    onDateClick() {
      console.log("event",this.event)
      if (this.profile != "" && this.Conditions != "") {
        let can_push = true;
        this.event.forEach(element => {
          if (
            this.date_picker_model.date.toString() == element.date.toString()
          ) {
            can_push = false;
          }
        });
        if (can_push) {
          this.event.push({
            date: this.date_picker_model.date,
            profile_plan: this.profile,
            profile_condition: this.Conditions
          });
        }
      } else {
        this.snackbar = true;
        this.errmsg = "กรุณาเลือกแผนการทำงาน และ เงื่อนไขหักเงิน";
      }
    },
    onRemoveItem(index) {
      this.event.splice(index, 1);
    }
  }
};
</script>
<style>
@import url("https://fonts.googleapis.com/css?family=Kanit&display=swap");
้ h1,
h2,
h3,
h4,
h5,
h6,
span,
p {
  font-family: "Kanit", sans-serif;
}
.v-input--selection-controls {
  margin-top: 0;
}
 .v-card__text{
    padding:0px !important;
  }
</style>